import { Navigate } from 'react-router-dom';
import NotificationSetting from './components/notifications/notification-settings.component';
import PaymentFailureComponent from './components/stripe/payment-failure.component';
import PaymentSuccessComponent from './components/stripe/payment-success.component';
import PaymentRedirect from './components/stripe/paymentRedirect';
import PaymentResponse from './components/stripe/paymentResponse';
import StripeComponent from './components/stripe/planPaymentComponent';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import Register from './pages/Register';
import DeleteAccount from './pages/DeleteAccount';
import VerifyEmailComponent from './pages/VerifyEmail';
import BillingInfoComponent from './pages/account/billing/billing-info.component';
import AppSumoRegisteration from './pages/app-sumo/appSumoRegister.component';
import NoBrand from './pages/brand/noBrand.component';
import ChangePassword from './pages/changePassword/changePassword';
import GoogleRedirect from './pages/google-signin/googleRedirect.component';
import CreateUserFromToken from './pages/invite-users/createUserFromToken.component';
import NoPermissionComponent from './pages/no-permission.component';
import OnBoardingComponent from './pages/on-boarding/on-boarding.component';
import PaymentOnBoardingComponent from './pages/on-boarding/payment-onboarding.component';
import NoOrganization from './pages/organization/noOrganization.component';
import ResetPassword from './pages/resetPassword/resetPassword';
import DisableUserComponent from './pages/user-disable/disableUser.component';
import WelcomePageComponent from './pages/welcome/welcomePage.component';
import PrivateRouteComponent from './privateRoute';
import { CommonHelper } from './utils/commonHelper';
import WhiteLabel from './pages/branding/white-label.component';
import BrandingInfo from './pages/branding/branding-info.component';
import AgentInbox from './pages/AgentInbox/AgentInbox';
import TicketsPage from './pages/tickets/Tickets.component';
import AccountChangePassword from './pages/account/accountChangePassword';
import Account from './pages/account/accountGeneral';
import CouponUpdateComponent from './pages/app-sumo/coupon-update.component';
import BrandInfoComponent from './pages/brand/brandInfo.component';
import AIChatSetup from './pages/chat-setup/aiChatSetup.component';
import ChatSetup from './pages/chat-setup/chatSetup.component';
import FAQSetup from './pages/chat-setup/faqSetup.component';
import KBArticlesSetup from './pages/chat-setup/kbArticlesSetup.component';
import KBCollectionsSetup from './pages/chat-setup/kbCollectionsSetup.component';
import KBSetup from './pages/chat-setup/kbSetup.component';
import LiveChatContacts from './pages/chat-setup/liveChatContacts.component';
import LiveChatSetup from './pages/chat-setup/liveChatSetup.component';
import PublicKB from './pages/chat-setup/publicKB.component';
import TicketSetup from './pages/chat-setup/ticketSetup.component';
import WidgetSetup from './pages/chat-setup/widgetSetup.component';
import IntegrationsPage from './pages/integrations/integrations.component';
import FacebookRedirect from './pages/integrations/facebookRedirect.component';
import InstagramRedirect from './pages/integrations/instagramRedirect.component';
import WhatsAppRedirect from './pages/integrations/whatsappRedirect.component';
import FacebookChatPage from './pages/facebook-chat/facebookChat.component';
import InstagramChatPage from './pages/instagram-chat/instagramChat.component';
import WhatsAppChatPage from './pages/whatsapp-chat/whatsappChat.component';
import GetStartedComponent from './pages/get-started/get-started.component';
import ManageRoles from './pages/manage-roles/manageRoles.component';
import ManageUsers from './pages/manage-users/manageUsers.component';
import OrgManageBrand from './pages/organization/organizationBrand';
import OrgInfoComponent from './pages/organization/organizationInfo';
import OrgManageUsers from './pages/organization/organizationUsers';
import ProfileDetails from './pages/profile-details/profile-details';
import SupportAnalyticsDashboard from './pages/support-analytics/SupportAnalyticsDashboard';
import PendingUsers from './pages/users/pendingUsers.component';
import WelcomePageForAdTracking from './pages/welcome/welcome-page-for-ad-tracking';
import WelcomePageForLifeTimeUserComponent from './pages/welcome/welcome-page-for-lifetime-user';

const PrivateRoute = () => {
  const requireProfessionalTicketPlan = (children) =>
    CommonHelper.HasProfessionalPlan() ? children : <Navigate to="/live-chat" replace />;

  return [
    {
      path: 'profile',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ACCOUNT_MANAGEMENT}`}>
          <Account />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'change-password',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ACCOUNT_MANAGEMENT}`}>
          <AccountChangePassword />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'profile-details',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ACCOUNT_MANAGEMENT}`}>
          <ProfileDetails />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'billing',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ORG_ADMIN}`}>
          <BillingInfoComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'manage-brand',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ACCOUNT_MANAGEMENT}`}>
          <BrandInfoComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'manage-roles',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          <ManageRoles />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'manage-users',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          <ManageUsers />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'pending-users',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          <PendingUsers />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'manage-organization',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ACCOUNT_MANAGEMENT}`}>
          <OrgInfoComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'manage-org-brands',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ORG_ADMIN}`}>
          <OrgManageBrand />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'manage-org-users',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ORG_ADMIN}`}>
          <OrgManageUsers />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'notification-settings',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ACCOUNT_MANAGEMENT}`}>
          <NotificationSetting />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'support-setup',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ACCOUNT_MANAGEMENT}`}>
          <ChatSetup />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'widget',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          <WidgetSetup />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'faq',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          <FAQSetup />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'kb-info',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          <KBSetup />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'kb-collections',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          <KBCollectionsSetup />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'kb-articles',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          <KBArticlesSetup />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'ai-chat',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          <AIChatSetup />
        </PrivateRouteComponent>
      ),
    },
     {
      path: 'branding',
      element: (
        <PrivateRouteComponent permissions={CommonHelper.PermissionList.ORG_ADMIN}>
          <BrandingInfo/>
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'white-label',
      element: (
        <PrivateRouteComponent permissions={CommonHelper.PermissionList.ORG_ADMIN}>
          <WhiteLabel/>
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'integrations',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          <IntegrationsPage />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'live-chat',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          <LiveChatSetup />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'ticket-setup',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          {requireProfessionalTicketPlan(<TicketSetup />)}
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'agent-inbox',
      element: (
        <PrivateRouteComponent  permissions={`${CommonHelper.PermissionList.LIVE_CHAT_MANAGE}`}>
          <AgentInbox/>
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'whatsapp-chat',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.LIVE_CHAT_MANAGE}`}>
          <WhatsAppChatPage />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'facebook-chat',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.LIVE_CHAT_MANAGE}`}>
          <FacebookChatPage />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'instagram-chat',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.LIVE_CHAT_MANAGE}`}>
          <InstagramChatPage />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'tickets',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.LIVE_CHAT_MANAGE}`}>
          {requireProfessionalTicketPlan(<TicketsPage />)}
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'contacts',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.LIVE_CHAT_MANAGE}`}>
          <LiveChatContacts />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'support-analytics',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ANALYTICS_VIEW}`}>
          <SupportAnalyticsDashboard />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'stripe-payment',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ORG_ADMIN}`}>
          <StripeComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'get-started',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          <GetStartedComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'welcome',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ACCOUNT_MANAGEMENT}`}>
          <WelcomePageComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'welcome-lifetime-user',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ACCOUNT_MANAGEMENT}`}>
          <WelcomePageForLifeTimeUserComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'welcome-ad-lifetime',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ACCOUNT_MANAGEMENT}`}>
          <WelcomePageForAdTracking />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'welcome-ad',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ACCOUNT_MANAGEMENT}`}>
          <WelcomePageForAdTracking />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'coupon-update',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ORG_ADMIN}`}>
          <CouponUpdateComponent />
        </PrivateRouteComponent>
      ),
    },
  ];
};

const PublicRoutes = () => {
  return [
    {
      path: 'not-found',
      element: <Page404 />,
    },
    {
      path: 'no-permission',
      element: <NoPermissionComponent />,
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'reset-password',
      element: <ResetPassword />,
    },
    {
      path: 'change-password',
      element: <ChangePassword />,
    },
    {
      path: 'register',
      element: <Register />,
    },
    {
      path: 'delete-account',
      element: <DeleteAccount />,
    },
    {
      path: 'coupon-register',
      element: <AppSumoRegisteration />,
    },
    {
      path: 'payment-response',
      element: <PaymentResponse />,
    },
    {
      path: 'knowledge-base/:brandId',
      element: <PublicKB />,
    },
    {
      path: 'knowledge-base/:brandId/collection/:collectionSlug',
      element: <PublicKB />,
    },
    {
      path: 'knowledge-base/:brandId/collection/:collectionSlug/:articleSlug',
      element: <PublicKB />,
    },
    {
      path: 'knowledge-base/:brandId/:articleSlug',
      element: <PublicKB />,
    },
    {
      path: '*',
      element: <Navigate to="/login" replace />,
    },
    {
      path: 'verify-user',
      element: <VerifyEmailComponent />,
    },
    {
      path: 'create-invite-user',
      element: <CreateUserFromToken />,
    },
    {
      path: 'no-brand',
      element: <NoBrand />,
    },
    {
      path: 'no-organization',
      element: <NoOrganization />,
    },
    {
      path: 'user-disable',
      element: <DisableUserComponent />,
    },
   
    {
      path: 'google-redirect',
      element: <GoogleRedirect />,
    },
    {
      path: 'whatsapp-redirect',
      element: <WhatsAppRedirect />,
    },
    {
      path: 'facebook-redirect',
      element: <FacebookRedirect />,
    },
    {
      path: 'instagram-redirect',
      element: <InstagramRedirect />,
    },

    {
      path: 'payment-redirect',
      element: <PaymentRedirect />,
    },
    {
      path: 'payment-failure',
      element: <PaymentFailureComponent />,
    },
    {
      path: 'payment-success',
      element: <PaymentSuccessComponent />,
    },
    {
      path: 'on-boarding',
      element: <OnBoardingComponent />,
    },
    {
      path: 'payment-boarding',
      element: <PaymentOnBoardingComponent />,
    },
  ];
};

export const Routes = {
  PublicRoutes,
  PrivateRoute,
};






